import { useQuery } from '@tanstack/react-query';

export type FamilyRole = {
  id: string;
  name: string;
};

export const useFamilyRoles = () => {
  const { data, isLoading, error } = useQuery<FamilyRole[]>({
    queryKey: ['family-roles'],
  });

  return {
    familyRoles: data ?? [],
    isLoading,
    error,
  };
};
